export default {"src":"/_next/static/media/eye.e09779e7.svg","height":44,"width":44};